module.exports = __webpack_public_path__ + "img/alitas_1.7b4fa98f.jpeg";